<template>
    <div class="already-set">
        <a-table class="stock-table" :columns="table.columns" :data-source="table.data" :loading="table.loading"
            :pagination="table.pagination" rowKey="id" @change="tableChanged" bordered>

            <div slot="time" slot-scope="time">
                {{ formatTime(time) }}
            </div>

            <div slot="op" class="btn-groups" slot-scope="val,item">
                <img src="/assets/images/contract-icon-edit.png" @click="editContract(item)">
                <img src="/assets/images/contract-icon-del.png" @click="delContract(item)">
            </div>

        </a-table>

        <div class="btn-box">
            <button class="btn" @click="create">新增模板合同</button>
        </div>
    </div>
</template>

<script>
import api from '@/repo/api';
import moment from "moment/moment";
export default {
    name: "alreadySet",
    data() {
        return {
            table: {
                columns: [
                    {
                        width: 100,
                        title: '序号',
                        dataIndex: 'num',
                        align: 'center',
                        customRender: (text,record,index) => `${index+1}`,
                    },
                    {
                        width: 200,
                        title: '合同设定时间',
                        dataIndex: 'created_at',
                        scopedSlots: {customRender: 'time'},
                        align: 'center',
                    },
                    {
                        width: 540,
                        title: '模板合同名称',
                        dataIndex: 'title',
                        align: 'center',
                    },
                    {
                        title: '操作',
                        dataIndex: 'op',
                        align: 'center',
                        scopedSlots: { customRender: 'op' },
                    }
                ],
                loading: true,
                data: [],
                pagination: {
                    defaultCurrent: 1,
                    current: 1,
                    defaultPageSize: 10,
                    total: 1,
                    pageSize: 20
                },
            },
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        formatTime(time) {
            return moment(time).format('yyyy-MM-DD HH:mm')
        },
        // 表格分页
        tableChanged(pagination) {
            this.query.page = pagination.current;
            this.getList();
        },
        // 获取列表数据
        getList() {
            this.table.loading = true;
            api.get('/ast-contract/contracts', (res) => {
                if (res.code === 0) {
                    this.table.data = res.data;
                    this.table.loading = false;
                } else {
                    this.$message.error(res.msg);
                }
            }); 
        },
        // 新增模板合同
        create() {
            this.$emit('create');
        },
        // 编辑
        editContract(item) {
            console.log('编辑: ',item);
            this.$emit('edit',item.id);
            // 编辑和删除之后要更新列表数据
        },
        // 删除
        delContract(item) {
            console.log('删除: ',item);
            this.$emit('del',item.id);
            // 编辑和删除之后要更新列表数据
        }
    }
}
</script>

<style lang="less" scoped>
    .btn-groups{
        width: 72px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        img{
            width: 24px;
            height: 24px;
        }
    }
</style>